import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "next",
  "use": "next-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"next\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.081 5.464L12.65 7.07l-11.182.098a.698.698 0 00-.694.717.724.724 0 00.728.705l11.182-.098-1.491 1.633a.73.73 0 00.024.995.67.67 0 00.98-.01l2.604-2.85a.73.73 0 00-.024-.994L12.04 4.46a.67.67 0 00-.982.009.73.73 0 00.024.994z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol